function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  rx: 21,
  fill: "#E11B7E"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  rx: 21,
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  rx: 21,
  fill: "url(#paint1_radial)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  rx: 21,
  fill: "url(#paint2_radial)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.3451 10.3276C18.3532 10.3276 17.9777 10.3407 16.8026 10.3942C15.6298 10.4479 14.8293 10.6336 14.1288 10.906C13.4042 11.1874 12.7896 11.5638 12.1773 12.1763C11.5645 12.7887 11.1881 13.4033 10.9058 14.1276C10.6327 14.8283 10.4468 15.6291 10.394 16.8014C10.3414 17.9765 10.3276 18.3522 10.3276 21.3441C10.3276 24.336 10.3409 24.7104 10.3942 25.8855C10.4481 27.0583 10.6338 27.8588 10.906 28.5593C11.1876 29.2838 11.564 29.8985 12.1766 30.5108C12.7887 31.1236 13.4033 31.5009 14.1274 31.7823C14.8283 32.0547 15.6291 32.2404 16.8017 32.2941C17.9768 32.3476 18.352 32.3607 21.3437 32.3607C24.3358 32.3607 24.7101 32.3476 25.8852 32.2941C27.058 32.2404 27.8595 32.0547 28.5604 31.7823C29.2848 31.5009 29.8985 31.1236 30.5106 30.5108C31.1234 29.8985 31.4998 29.2838 31.7821 28.5595C32.0529 27.8588 32.2388 27.058 32.2939 25.8857C32.3467 24.7106 32.3604 24.336 32.3604 21.3441C32.3604 18.3522 32.3467 17.9768 32.2939 16.8017C32.2388 15.6289 32.0529 14.8283 31.7821 14.1279C31.4998 13.4033 31.1234 12.7887 30.5106 12.1763C29.8978 11.5636 29.285 11.1872 28.5597 10.906C27.8574 10.6336 27.0564 10.4479 25.8836 10.3942C24.7085 10.3407 24.3344 10.3276 21.3416 10.3276H21.3451ZM20.3568 12.3131C20.6501 12.3126 20.9774 12.3131 21.345 12.3131C24.2865 12.3131 24.6351 12.3236 25.7966 12.3764C26.8707 12.4255 27.4537 12.605 27.842 12.7558C28.3561 12.9555 28.7227 13.1941 29.108 13.5797C29.4936 13.9653 29.7323 14.3325 29.9324 14.8466C30.0832 15.2345 30.2629 15.8175 30.3118 16.8916C30.3646 18.0529 30.3761 18.4017 30.3761 21.3418C30.3761 24.2818 30.3646 24.6307 30.3118 25.792C30.2627 26.8661 30.0832 27.4491 29.9324 27.8369C29.7327 28.351 29.4936 28.7171 29.108 29.1024C28.7224 29.488 28.3564 29.7267 27.842 29.9264C27.4542 30.0779 26.8707 30.2569 25.7966 30.306C24.6353 30.3588 24.2865 30.3703 21.345 30.3703C18.4034 30.3703 18.0548 30.3588 16.8935 30.306C15.8193 30.2564 15.2364 30.0769 14.8478 29.9262C14.3337 29.7265 13.9665 29.4878 13.5809 29.1022C13.1954 28.7166 12.9567 28.3503 12.7565 27.836C12.6057 27.4481 12.426 26.8652 12.3771 25.7911C12.3244 24.6297 12.3138 24.2809 12.3138 21.339C12.3138 18.3972 12.3244 18.0501 12.3771 16.8888C12.4263 15.8147 12.6057 15.2317 12.7565 14.8434C12.9562 14.3293 13.1954 13.9621 13.5809 13.5765C13.9665 13.1909 14.3337 12.9522 14.8478 12.7521C15.2362 12.6006 15.8193 12.4216 16.8935 12.3723C17.9097 12.3264 18.3036 12.3126 20.3568 12.3103V12.3131ZM27.2259 14.1423C26.496 14.1423 25.9039 14.7338 25.9039 15.4638C25.9039 16.1937 26.496 16.7858 27.2259 16.7858C27.9557 16.7858 28.5479 16.1937 28.5479 15.4638C28.5479 14.734 27.9557 14.1418 27.2259 14.1418V14.1423ZM21.3448 15.6868C18.2205 15.6868 15.6874 18.2199 15.6874 21.3442C15.6874 24.4685 18.2205 27.0005 21.3448 27.0005C24.4691 27.0005 27.0013 24.4685 27.0013 21.3442C27.0013 18.2199 24.4689 15.6868 21.3446 15.6868H21.3448ZM21.3454 17.6724C23.3734 17.6724 25.0176 19.3163 25.0176 21.3445C25.0176 23.3725 23.3734 25.0167 21.3454 25.0167C19.3172 25.0167 17.6733 23.3725 17.6733 21.3445C17.6733 19.3163 19.3172 17.6724 21.3454 17.6724Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 4.61426,
  y1: -2.06141e-7,
  x2: 18.416,
  y2: 37.6318,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#4263DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D53585",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.24902 42) rotate(-36.1187) scale(38.7918)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#FFAD05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF3F00",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.9971 42) rotate(-40.6013) scale(26.2811)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#FDDB86"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F06942",
  stopOpacity: 0
})));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7a7d31d01bdc09bb3ac4798c8743a651.svg";
export { ForwardRef as ReactComponent };